/* =========================================================
   Forged Power — Theme JS
   Lightweight, no-dependency reactive helpers.
========================================================= */

(function () {
  'use strict';

  // ---- Reveal on scroll ---------------------------------
  const animationsEnabled = document.documentElement.dataset.animations !== 'false';
  if (animationsEnabled && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('[data-reveal]').forEach(el => io.observe(el));
  } else {
    document.documentElement.classList.add('no-anim');
  }

  // ---- Mobile menu --------------------------------------
  const menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  const menuClose = document.querySelector('[data-mobile-menu-close]');
  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
    if (menuToggle) menuToggle.setAttribute('aria-expanded', open);
  }
  menuToggle && menuToggle.addEventListener('click', () => setMenu(!menu.classList.contains('is-open')));
  menuClose && menuClose.addEventListener('click', () => setMenu(false));

  // ---- Cart drawer --------------------------------------
  const drawer = document.getElementById('CartDrawer');
  const drawerBody = document.getElementById('CartDrawerBody');

  function openDrawer() { if (drawer) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; refreshCart(); } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } }

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-cart-open]');
    const close = e.target.closest('[data-cart-close]');
    if (open) { e.preventDefault(); openDrawer(); }
    if (close) { e.preventDefault(); closeDrawer(); }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeDrawer(); setMenu(false); }
  });

  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    return (window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active + ' ' : '$') + value;
  }

  function renderCart(cart) {
    if (!drawerBody) return;
    if (!cart.items || cart.items.length === 0) {
      drawerBody.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      updateCount(0);
      return;
    }
    let html = '';
    cart.items.forEach(item => {
      html += `
        <div class="cart-line" data-line-key="${item.key}">
          <div class="cart-line__media">
            ${item.image ? `<img src="${item.image}" alt="${item.product_title}">` : ''}
          </div>
          <div class="cart-line__info">
            <a class="cart-line__title" href="${item.url}">${item.product_title}</a>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<span class="cart-line__variant">${item.variant_title}</span>` : ''}
            <span>${formatMoney(item.final_line_price)}</span>
            <div class="cart-line__qty">
              <button type="button" data-qty-decrease aria-label="Decrease">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-qty-increase aria-label="Increase">+</button>
              <button type="button" class="cart-line__remove" data-qty-remove>Remove</button>
            </div>
          </div>
        </div>
      `;
    });
    html += `
      <div class="cart-drawer__footer">
        <div class="cart-drawer__totals">
          <span>Subtotal</span>
          <span>${formatMoney(cart.total_price)}</span>
        </div>
        <a href="/checkout" class="btn btn--primary btn--block">Checkout</a>
      </div>
    `;
    drawerBody.innerHTML = html;
    updateCount(cart.item_count);
  }

  function updateCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(renderCart)
      .catch(() => {});
  }

  function changeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(r => r.json()).then(renderCart);
  }

  document.addEventListener('click', (e) => {
    const line = e.target.closest('.cart-line');
    if (!line) return;
    const key = line.dataset.lineKey;
    const qtySpan = line.querySelector('.cart-line__qty span');
    const current = qtySpan ? parseInt(qtySpan.textContent, 10) : 1;
    if (e.target.matches('[data-qty-increase]')) changeLine(key, current + 1);
    if (e.target.matches('[data-qty-decrease]')) changeLine(key, Math.max(0, current - 1));
    if (e.target.matches('[data-qty-remove]')) changeLine(key, 0);
  });

  // ---- Add to cart (AJAX) -------------------------------
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action^="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const submitBtn = form.querySelector('[type="submit"]');
    const originalText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }
    const data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(() => {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Added ✓'; setTimeout(() => submitBtn.textContent = originalText, 1500); }
        openDrawer();
      })
      .catch(() => {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
        form.submit();
      });
  });

  // initial cart count
  if (document.querySelector('[data-cart-count]')) refreshCart();

  // ---- Product gallery ----------------------------------
  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const main = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.src;
        if (main && src) {
          main.src = src;
          main.srcset = thumb.dataset.srcset || '';
        }
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });

  // ---- Variant picker -----------------------------------
  document.querySelectorAll('[data-variant-form]').forEach(form => {
    const productEl = form.closest('[data-product-json]');
    let product = null;
    try { product = productEl ? JSON.parse(productEl.dataset.productJson) : null; } catch (e) {}
    if (!product) return;

    const priceEl = form.querySelector('[data-product-price]');
    const submitBtn = form.querySelector('[type="submit"]');
    const variantInput = form.querySelector('input[name="id"]');

    function pickedOptions() {
      return Array.from(form.querySelectorAll('input[name^="options"]:checked')).map(i => i.value);
    }
    function findVariant(opts) {
      return product.variants.find(v => v.options.every((o, i) => o === opts[i]));
    }
    function updateVariant() {
      const opts = pickedOptions();
      const variant = findVariant(opts);
      if (variant) {
        if (variantInput) variantInput.value = variant.id;
        const inventoryTracked = !!variant.inventory_management;
        const outOfStockByCount = inventoryTracked && (variant.inventory_quantity || 0) <= 0;
        const isSoldOut = !variant.available || !(variant.price > 0) || outOfStockByCount;
        if (priceEl) {
          if (isSoldOut) {
            priceEl.innerHTML = '<span class="product-info__soldout">Sold out</span>';
            priceEl.classList.add('product-info__price--soldout');
          } else {
            priceEl.textContent = formatMoney(variant.price);
            priceEl.classList.remove('product-info__price--soldout');
          }
        }
        if (submitBtn) {
          submitBtn.disabled = !variant.available;
          submitBtn.textContent = variant.available ? (submitBtn.dataset.addText || 'Add to cart') : 'Sold out';
        }
      }
    }
    form.addEventListener('change', updateVariant);
    updateVariant();
  });

  // ---- Quantity steppers --------------------------------
  document.addEventListener('click', (e) => {
    const inc = e.target.closest('[data-qty-step]');
    if (!inc) return;
    const wrap = inc.closest('.qty-selector');
    if (!wrap) return;
    const input = wrap.querySelector('input');
    if (!input) return;
    const step = parseInt(inc.dataset.qtyStep, 10);
    input.value = Math.max(1, parseInt(input.value || '1', 10) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ---- Lifelike product imagery -------------------------
  // Cursor-tracked spotlight + subtle 3D tilt for product cards and the
  // PDP gallery main image. Desktop / fine-pointer only; respects
  // prefers-reduced-motion.
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (animationsEnabled && !reduceMotion && finePointer) {
    const tiltTargets = [
      { card: '.product-card', stage: '.product-card__media', max: 6 },
      { card: '.product-gallery', stage: '.product-gallery__main', max: 8 }
    ];

    tiltTargets.forEach(({ card, stage, max }) => {
      document.querySelectorAll(card).forEach(el => {
        const target = el.querySelector(stage);
        if (!target) return;
        let raf = 0;
        const onMove = (e) => {
          const rect = target.getBoundingClientRect();
          const x = (e.clientX - rect.left) / rect.width;
          const y = (e.clientY - rect.top) / rect.height;
          const rotY = (x - 0.5) * 2 * max;
          const rotX = (0.5 - y) * 2 * max;
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => {
            target.style.setProperty('--spot-x', (x * 100).toFixed(2) + '%');
            target.style.setProperty('--spot-y', (y * 100).toFixed(2) + '%');
            target.style.transform = `translateZ(0) rotateX(${rotX.toFixed(2)}deg) rotateY(${rotY.toFixed(2)}deg)`;
          });
        };
        const onLeave = () => {
          if (raf) cancelAnimationFrame(raf);
          target.style.transform = '';
          target.style.removeProperty('--spot-x');
          target.style.removeProperty('--spot-y');
        };
        el.addEventListener('pointermove', onMove);
        el.addEventListener('pointerleave', onLeave);
      });
    });
  }

  // Coarse-pointer (touch / mobile): reveal product cards on scroll-in
  // with a soft lift so they still feel three-dimensional.
  if (animationsEnabled && !reduceMotion && !finePointer && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('pc-lift');
    const cardIO = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-lifted');
          cardIO.unobserve(e.target);
        }
      });
    }, { threshold: 0.25 });
    document.querySelectorAll('.product-card').forEach(el => cardIO.observe(el));
  }

  // ---- Video play poster --------------------------------
  document.querySelectorAll('[data-video-trigger]').forEach(btn => {
    btn.addEventListener('click', () => {
      const wrap = btn.closest('[data-video-section]');
      const video = wrap && wrap.querySelector('video');
      const iframe = wrap && wrap.querySelector('iframe');
      if (video) { video.play(); video.controls = true; }
      if (iframe) {
        const src = iframe.dataset.src;
        if (src && !iframe.src) iframe.src = src;
      }
      btn.hidden = true;
    });
  });
})();
